import {
  isMobile, osVersion, osName,
} from 'react-device-detect';
import ApiService from './ApiService';

class ProbeService {
  constructor() {
    this.data = {};
  }

  /**
   * Add probe
   * @param lastAction - Action of the probe
   * @param service - The service ID
   * @param route - Current route pathname
   * @param elapsed - Duration between the two last actions
   */
  addProbe = ({
    elapsed, route, lastAction, service = 'default',
  }) => {
    this.data = {
      action: lastAction,
      value: elapsed,
      name: route,
      service,
      os: `${osName} ${osVersion}`,
      resolution: `${window.innerWidth}x${window.innerHeight}`,
      ontouch: isMobile,
      webViewMode: false,
    };
  };

  /**
   * Send probes to the server
   * @return {Promise<void>}
   */
  sendProbe = () => ApiService.sendProbes(this.data);
}

export default new ProbeService();
